import type { CommandSegment } from '../../store/types'
import './BashSegments.css'

/// Risk-colored Bash segments. The server annotates each subcommand of a
/// compound command (`a && b && c`) with a risk tier and a hasRule flag
/// that tells us whether an existing grant already approves it. Each
/// segment renders with a 4px left stripe in the risk color and a
/// matching tinted background; segments are joined by a dim "&&" label.
export function BashSegments({ segments }: { segments: CommandSegment[] }) {
  if (segments.length === 0) return null
  return (
    <div className="bash-segs">
      {segments.map((seg, i) => (
        <div key={i}>
          <SegmentCell segment={seg} />
          {i < segments.length - 1 && (
            <div className="bash-segs__joiner">&&</div>
          )}
        </div>
      ))}
    </div>
  )
}

function SegmentCell({ segment }: { segment: CommandSegment }) {
  const color = riskColor(segment.risk)
  return (
    <div
      className="bash-segs__cell"
      style={{
        background: `color-mix(in srgb, ${color} 8%, var(--bg-system))`,
        borderColor: `color-mix(in srgb, ${color} 25%, transparent)`,
      }}
    >
      <div className="bash-segs__stripe" style={{ background: color }} />
      <pre className="bash-segs__command">{segment.command}</pre>
      {segment.has_rule && (
        <div className="bash-segs__rule-badge" aria-label="Already covered by a rule">
          ✓
        </div>
      )}
    </div>
  )
}

export function riskColor(risk: CommandSegment['risk']): string {
  switch (risk) {
    case 'high':
      return 'var(--danger)'
    case 'low':
      return 'var(--success)'
    case 'medium':
    default:
      return 'var(--warning)'
  }
}
